<template>
  <div class="about">
    <AboutPage/>
  </div>
</template>

<script>
import AboutPage from '@/components/AboutPage.vue'

export default {
  name: 'AboutView',
  components: {
    AboutPage
  }
}
</script>